exports = module.exports = require("../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home-timetable-location {\n\tpadding-left: 10px;\n\tpadding-right: 10px;\n\n\tpadding-top: 4em;\n\tpadding-bottom: 2em;\n\n\t\n}\n\n#home-timetable-location > div  {\n\ttext-align: center;\n\tcolor: #ffb97b;\n}\n\n#home-timetable-location > div > h5 {\n\n}\n\n#home-timetable-location > div > table {\n\t//text-align: left;\n\twidth: 100%;\n}\n\n#home-contact-address-phone {\n\tfont-size: 10pt;\n}\n\ntd {\n\t//font-size: 10pt;\n\tpadding: 0;\n}\n\ntable {\n\tcolor: black;\n\t//font-size: 14pt;\n}\n\n#home-timetable-location > div > p {\n\tmargin-bottom: 0;\n\tcolor: black;\n\t//font-size: 13px;\n}\n\nagm-map {\n    height:400px;\n    width:100%;\n}\n\n.infoWindowContent {\n    font-size:  10px !important;\n    border-top: 1px solid #ccc;\n    padding-top: 10px;\n}\n\n.repeat-item.ng-enter,\n.repeat-item.ng-leave {\n  transition:0.5s linear all;\n}\n\n.repeat-item.ng-enter,\n.repeat-item.ng-leave.ng-leave-active {\n  opacity:0;\n}\n.repeat-item.ng-leave,\n.repeat-item.ng-enter.ng-enter-active {\n  opacity:1;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/timetable-location.component.css
// module id = ../../../../../src/app/timetable-location.component.css
// module chunks = main